import { Command, Editor, Element, NodeAttributes } from "ckeditor5";

export default class WrapInElementCommand extends Command {
  private elementName: string;
  private elementAttrs: NodeAttributes | undefined;
  private isSelectionRequired: boolean;
  private element: Element | null = null;

  value = false;

  constructor(
    editor: Editor,
    elementName: string,
    isSelectionRequired: boolean,
  ) {
    super(editor);
    this.elementName = elementName;
    this.isSelectionRequired = isSelectionRequired;
  }

  refresh() {
    const selection = this.editor.model.document.selection;
    const containingElement = selection
      .getFirstPosition()
      ?.findAncestor(this.elementName);

    if (containingElement != null) {
      this.value = true;
      this.isEnabled = !this.editor.isReadOnly;
      this.element = containingElement;
      return;
    }

    this.value = false;
    this.element = null;

    const range = selection.getFirstRange();
    const ancestor = range?.getCommonAncestor();
    if (range == null || !ancestor?.is("element")) {
      this.isEnabled = false;
      return;
    }

    this.isEnabled =
      !this.editor.isReadOnly &&
      this.editor.model.schema.checkChild(ancestor, this.elementName) &&
      Array.from(range.getItems()).every((item) =>
        this.editor.model.schema.checkChild(
          this.elementName,
          item.is("$textProxy") ? "$text" : item,
        ),
      ) &&
      (!selection.isCollapsed || !this.isSelectionRequired);
  }

  execute() {
    return this.editor.model.change((writer) => {
      if (this.element != null) {
        writer.unwrap(this.element);
        return false;
      }

      const range = this.editor.model.document.selection.getFirstRange();
      if (range == null) return undefined;

      const element = new Element(this.elementName, this.elementAttrs);

      writer.wrap(range, element);
      return true;
    });
  }
}
